/* ================================================================
   ★ CONFIG — 여기만 수정하세요
   ================================================================ */

export const SITE_TITLE = "Game 참여인원 관리자";
export const SIDEBAR_FULL = 220;
export const SIDEBAR_MINI = 52;

export const PROGRAMS = [
  {
    id: "spyx",
    name: "스파이x",
    appId: "iSAfLB3Yu649eDt2gvCbJg9LHU7RbsYhzpdzMLSR",
    jsKey: "cXuIq8tOiwtopr2fNcEGkpBcnf21kPOLwF5bRqUH",
    apiKey: "XpnMoCTPF41wQwHNVTodpBepTT3e9ygRuUODbdoR",
    restKey: "XpnMoCTPF41wQwHNVTodpBepTT3e9ygRuUODbdoR",
    prefix: "sp",
    roles: ["spyX", "spyY"],
    tableId: "spyx",
    codeTable: "spyx_Code",
    surveyTable: "spyx_Survey",
    codeField: "introInCode",
    nameField: "playerName",
    teamField: "introTeam",
  },
  {
    id: "silence",
    name: "침묵의방",
    appId: "iSAfLB3Yu649eDt2gvCbJg9LHU7RbsYhzpdzMLSR",
    jsKey: "cXuIq8tOiwtopr2fNcEGkpBcnf21kPOLwH5bRqUH",
    restKey: "XpnMoCTPF41wQwHNVTodpBepTT3e9ygRuUODbdoR",
    prefix: "si",
    roles: [],
    tableId: "Silence_Round1",
    codeTable: "Silence_Code",
    surveyTable: "silence1_Survey",
    codeField: "introInCode",
    nameField: "playerName",
    teamField: "introTeam",
  },
  {
    id: "stress",
    name: "스트레스 버그",
    appId: "HTorVAkvDQ4yFg4XR0xoUS7pM3oboBkXcXZjDvMT",
    jsKey: "f05aHpR5M6CGR0ZIZ5NosJ7ApFZ8JzUVhFgeYbyg",
    restKey: "Mz2bQZVvSyWYlasWRLj8uro0zLrcY7XIqx2cVfDL",
    prefix: "st",
    roles: [],
    tableId: "game_logs",
    codeTable: "game_Code",
    surveyTable: "survey",
    codeField: "entry_code",
    nameField: "team_name",
    teamField: "team_name",
    dateField: "use_date",
  },
];

/* 설문 질문 정의 */
export const SURVEY_QUESTIONS = [
  { key: "q1", label: "전반적 만족도", type: "score", max: 5 },
  { key: "q2", label: "미션 난이도", type: "score", max: 5 },
  { key: "q3", label: "팀원 협력", type: "score", max: 5 },
  { key: "q4", label: "기분 변화", type: "score", max: 5 },
  {
    key: "q5",
    label: "인상 깊었던 요소",
    type: "choice",
    options: [
      "미션 내용 · 스토리",
      "팀원과의 협동 순간",
      "경쟁 · 점수 체계",
      "새로운 공간과 분위기",
      "진행 방식 · 운영",
    ],
  },
  { key: "q6", label: "개선 의견", type: "text" },
  { key: "q7", label: "추천 의향", type: "score", max: 5 },
];

export const GAME_DURATIONS = [10, 20, 30, 40, 50, 60, 90, 120];

export const REPORT_CONFIG = [
  {
    programId: "spyx",
    table: "spyx",
    columns: [
      { key: "playerName", label: "닉네임" },
      { key: "score", label: "점수" },
      { key: "clearTime", label: "시간" },
      { key: "userRole", label: "역할" },
    ],
  },
];

export const COURSE_CLASS = "CourseList";
export const P1 = PROGRAMS[0];
export const PROGRAM_MAP = Object.fromEntries(PROGRAMS.map((p) => [p.id, p]));

export const C = {
  accent: "#5c7cce",
  accentDim: "#4a6abf",
  accentBg: "#e8eaf6",
  accentTxt: "#3949ab",
  bg: "#f5f5f7",
  surface: "#ffffff",
  border: "#e0e0e0",
  border2: "#c8c8c8",
  t1: "#111111",
  t2: "#444444",
  t3: "#888888",
  hover: "#f0f0f5",
  selected: "#e8eaf6",
  danger: "#e53e5a",
  dangerBg: "#fff1f3",
};

export const todayStr = () => new Date().toISOString().slice(0, 10);
export const fmtTime = (s) => {
  if (s == null) return "—";
  const m = Math.floor(s / 60),
    ss = s % 60;
  return `${String(m).padStart(2, "0")}분 ${String(ss).padStart(2, "0")}초`;
};
export const makeCode = (prefix, round, num) => {
  const alpha = String.fromCharCode(96 + round);
  return `${prefix}${alpha}${String(num).padStart(3, "0")}`;
};
export const iS = {
  width: "100%",
  padding: "10px 12px",
  border: `1px solid ${C.border2}`,
  borderRadius: 9,
  fontSize: 13,
  color: C.t1,
  background: C.bg,
  outline: "none",
  fontFamily: "inherit",
  boxSizing: "border-box",
};
